import { Radio, TimePicker } from '@alifd/next';
import moment from 'moment';
import React, { useContext } from 'react';
import {ActivityContext} from '../../index';
import styles from '../../index.module.scss';

function PutPeriod() {
  const { taskParams, setTaskParams, pageDisable } = useContext(ActivityContext);
  return (
    <div>
      <div className={styles['cardBox']}>
        <div className={styles['titleBox']}>投放时间：</div>
        <Radio.Group
          direction={'hoz'}
          value={taskParams.launchTime.type}
          disabled={pageDisable}
          onChange={(v) =>{
            let newLaunchTime = {...taskParams.launchTime}
            setTaskParams({ 
              ...taskParams, 
              launchTime:{
                ...newLaunchTime,
                type:+v,
                startTime:'',
                endTime:'',
              }
            })
          }}
        >
          <Radio value={1}>
            全天
          </Radio>
          <Radio value={2}>
            <div className={styles['radioSmallBox']}>
            每天
              <TimePicker
                hasClear={false}
                // disabledHours={disabledItems(disabledHours)}
                // disabledMinutes={disabledItems(disabledMinutes)}
                format="H:mm:ss"
                disabled={pageDisable || +taskParams.launchTime.type!==2}
                value={taskParams.launchTime.startTime}
                onChange={(v) => {
                  let newLaunchTime = {...taskParams.launchTime}
                  setTaskParams({ 
                    ...taskParams, 
                    launchTime:{
                      ...newLaunchTime,
                      startTime:moment(v).format('H:mm:ss'),
                    }
                  })
                  // let hour = v._d.getHours() * 3600 * 1000;
                  // props.setBaseInfo({...props.params, crowdDelayTime: hour, lauchDelayTime: ''})
                  // setSelfTime(v)
                }}
              />
              至
              <TimePicker
                hasClear={false}
                // disabledHours={disabledItems(disabledHours)}
                // disabledMinutes={disabledItems(disabledMinutes)}
                format="H:mm:ss"
                disabled={pageDisable || +taskParams.launchTime.type!==2}
                value={taskParams.launchTime.endTime}
                onChange={(v) => {
                  let newLaunchTime = {...taskParams.launchTime}
                  setTaskParams({ 
                    ...taskParams, 
                    launchTime:{
                      ...newLaunchTime,
                      endTime:moment(v).format('H:mm:ss'),
                    }
                  })
                }}
              />
              期间内投放短信，超出时间顺延至次日可投放时段中发送
            </div>
          </Radio>
        </Radio.Group>
      </div>
      <div className={styles['putPeriodTips']}>平台支持关怀短信24h投放</div>
    </div>
  );
}

export default PutPeriod;
